export const defaultSeoConfig = {
  title: "포장재는 칼렛! | 포장재 맞춤제작·친환경 포장재 칼렛스토어",
  description:
    "박스·봉투·테이프·완충재부터 친환경 포장재까지. 기성품 구매, 소량인쇄, 로고인쇄, 브랜드 맞춤제작과 기업 대량견적을 한번에 해결하세요.",
  image:
    "https://file.caretbio.com/caretbio/b2c6985b05f7bef24ed2c91965b47455.jpg",
  keywords:
    "포장재, 포장재쇼핑몰, 포장재전문몰, 포장재맞춤제작, 포장재제작, 포장재주문제작, 포장재소량제작, 포장재소량인쇄, 포장재인쇄, 포장재견적, 포장재대량견적, 기업포장재, B2B포장재, 친환경포장재, 친환경포장, 재활용포장재, 종이포장재, 택배박스, 택배박스제작, 택배박스맞춤제작, 종이박스, 골판지박스, 포장박스, 포장박스제작, 택배봉투, 택배봉투제작, 친환경택배봉투, 생분해택배봉투, 종이봉투, 포장봉투, 지퍼백, 쇼핑백, 쇼핑백제작, 완충재, 포장완충재, 종이완충재, 친환경완충재, 에어완충재, 에어캡, 에어쿠션, 벌집완충재, 허니콤완충재, 테이프, 포장테이프, 종이테이프, 종이테이프제작, 종이테이프인쇄, 친환경테이프, 리펄프테이프, 재활용테이프, OPP테이프, 보냉포장재, 보온포장재, 아이스팩, 로고인쇄, 박스인쇄, 봉투인쇄, 브랜드패키지제작, 패키지제작, 패키지소량제작",
  author: "칼렛바이오, 칼렛스토어",
  siteName: "포장재는 칼렛! | 포장재 맞춤제작·친환경 포장재 칼렛스토어",
};
